import React from "react";
import { ReportsButton } from "./ReportsButton";

import SpecimensPerWeekGraph from "../../../SideBar/DetailsRouter/Reports/SpecimensPerWeekGraph";

export const Reports = ({ data, handleButtonClick }) => {
  return (
    <div style={{ maxWidth: "95%" }}>
      <SpecimensPerWeekGraph data={data} />
      <div
        style={{
          textAlign: "center",
          justifyContent: "center",
          marginTop: "20px",
          color: "#167bc3",
          fontFamily: "Roboto",
        }}
      >
        <div
          style={{
            display: "flex",
            margin: "10px",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{ marginBottom: "5px", fontWeight: "500", fontSize: "15px" }}
          >
            REPORTS
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "80px",
              overflowWrap: "anywhere",
              flexDirection: "row",
              maxWidth: "100%",
            }}
          >
            <ReportsButton
              handleButtonClick={handleButtonClick}
              buttonType={"Raw-Data"}
              title={"RAW DATA"}
            />
            <ReportsButton
              handleButtonClick={handleButtonClick}
              buttonType={"Species-Summary-Among-Collections"}
              title={
                <>
                  SPECIES SUMMARY AMONG <br /> COLLECTION SITES
                </>
              }
            />
            <ReportsButton
              handleButtonClick={handleButtonClick}
              buttonType={"Weekly-Species-report"}
              title={"WEEKLY SPECIES REPORT"}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            margin: "8px",
            flexDirection: "column",
            alignItems: "center",
            color: "#167bc3",
            fontFamily: "Roboto",
          }}
        >
          <div
            style={{ marginBottom: "5px", fontWeight: "500", fontSize: "15px" }}
          >
            GRAPHS
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "80px",
              overflowWrap: "anywhere",
              flexDirection: "row",
              maxWidth: "100%",
            }}
          >
            <ReportsButton
              handleButtonClick={handleButtonClick}
              buttonType={"Pie-chart"}
              title={
                <>
                  Species <br /> Summary
                </>
              }
              icon={"PieChartIcon"}
            />
            <ReportsButton
              handleButtonClick={handleButtonClick}
              buttonType={"Bar-chart"}
              title={
                <>
                  SPECIES SUMMARY AMONG <br /> COLLECTION SITES
                </>
              }
              icon={"BarChartIcon"}
            />
            <ReportsButton
              handleButtonClick={handleButtonClick}
              buttonType={"LineGraph-chart"}
              title={
                <>
                  SPECIES ABUNDANCE <br /> BY MONTH
                </>
              }
              icon={"ShowChartIcon"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
